import {
    AsLeftResultFormula,
    AsLeftTableF78Deviation2Eu1Formula,
    AsLeftTableF79Deviation2Eu2Formula,
    AsLeftTableF80Deviation2Eu3Formula
} from './P734.formulas';
import {
    AsFoundTestTableF39HmiInst1Formula,
    AsFoundTestTableF40HmiInst2Formula,
    AsFoundTestTableF41HmiInst3Formula, } from '../../../AsFoundTestTableSection/Data/P734/P734.formulas';
import { paddingAF } from '../M71/M71.data';
import { isEnabledcondition } from '../M611/M611.data';
import { disableAsLeftTestFields } from '../../../ALT_SolenoidLimitSection/Data/S71/S71.data';
import { generateUnitLabel } from '../../../AsFoundTestTableSection/Data/P734/P734.data';
import { Result } from 'journeys/portal/Forms/Sections.constants';

export const asLeftTestTableSectionDataP734 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'AsleftTest',
                label: 'As-Left Test',
                isLabel: true,
                xs: 12,
                fontWeight: '700',
                padding: '5px 0 0 8px'
            }]
        },
        {
            key: 2,
            fields: [{
                key: '%-HMI',
                label: '% - HMI',
                isLabel: true,
                xs: 2,
                fontWeight: 700,
                labelWidth: '100%',
                padding: '5px 0 5px 8px',
                fontSize: '9pt'
            },
            {
                key: 'TestSpeed',
                label: generateUnitLabel('Test Speed', formData),
                isLabel: true,
                xs: 2,
                fontWeight: 700,
                labelWidth: '100%',
                textAlign: 'center',
                marginTop: '15px',
                padding: paddingAF,
                fontSize: '9pt'
            },
            {
                key: 'AltSensorOutput',
                label: 'Sensor Output',
                isLabel: true,
                xs: 2,
                fontWeight: 700,
                textAlign: 'center',
                labelWidth: '100%',
                marginTop: '15px',
                padding: paddingAF,
                fontSize: '9pt'
            },
            {
                key: 'SystemReading',
                label: generateUnitLabel('System Reading', formData),
                isLabel: true,
                xs: 2,
                fontWeight: 700,
                labelWidth: '100%',
                textAlign: 'center',
                marginTop: '15px',
                padding: paddingAF,
                fontSize: '9pt'
            },
            {
                key: 'HMIReading',
                label: generateUnitLabel('HMI Reading', formData),
                isLabel: true,
                xs: 2,
                fontWeight: 700,
                labelWidth: '100%',
                textAlign: 'center',
                marginTop: '15px',
                padding: paddingAF,
                fontSize: '9pt'
            },
            {
                key: 'Deviation',
                label: generateUnitLabel('Deviation', formData),
                isLabel: true,
                xs: 2,
                fontWeight: 700,
                textAlign: 'center',
                marginTop: '15px',
                padding: paddingAF,
                fontSize: '9pt'
            }]
        },
        {
            key: 3,
            fields: [{
                key: 'F63Hmi2Inst1',
                value: isEnabledcondition(AsFoundTestTableF39HmiInst1Formula(formData), disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                xs: 2,
                width: '100%',
                labelWidth: '0',
                readOnly: true,
                height: '1.2rem',
                borderRight: '0',
                borderLeft: '0',
                borderBottom: '0',
                marginLeft: '4px'
            },
            {
                key: 'F1060AltTestSpeed1',
                value: isEnabledcondition(formData.F1060AltTestSpeed1, disableAsLeftTestFields(formData)),
                isRequired: !(disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                xs: 2,
                type: 'number',
                maxLength: '10',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
                borderBottom: '0'
            },
            {
                key: 'F1066AltSensorOutput',
                value: isEnabledcondition(formData.F1066AltSensorOutput, disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                xs: 2,
                maxLength: '20',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
                borderBottom: '0'
            },
            {
                key: 'F733AltSystemReading1',
                value: isEnabledcondition(formData.F733AltSystemReading1, disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                type: 'number',
                maxLength: '10',
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
                borderBottom: '0'
            },
            {
                key: 'F109AltHmireading1',
                value: isEnabledcondition(formData.F109AltHmireading1, disableAsLeftTestFields(formData)),
                isRequired: !(disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                type: 'number',
                maxLength: '10',
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderBottom: '0',
                borderRight: '0',
            },
            {
                key: 'F78Deviation2Eu1',
                value: isEnabledcondition(AsLeftTableF78Deviation2Eu1Formula(formData), disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: true,
                xs: 2,
                textAlign: 'center',
                width: '100%',
                labelWidth: '0',
                height: '1.2rem',
                borderBottom: '0',
                borderRight: '0',
                inputMarginRight: '4px',
            }]
        },
        {
            key: 4,
            fields: [{
                key: 'F64Hmi2Inst2',
                value: isEnabledcondition(AsFoundTestTableF40HmiInst2Formula(formData), disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                xs: 2,
                width: '100%',
                labelWidth: '0',
                readOnly: true,
                height: '1.2rem',
                borderRight: '0',
                borderLeft: '0',
                borderBottom: '0',
                marginLeft: '4px'
            },
            {
                key: 'F1061AltTestSpeed2',
                value: isEnabledcondition(formData.F1061AltTestSpeed2, disableAsLeftTestFields(formData)),
                isRequired: !(disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                maxLength: '10',
                xs: 2,
                type: 'number',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
                borderBottom: '0'
            },
            {
                key: 'F1067AltSensorOutput',
                value: isEnabledcondition(formData.F1067AltSensorOutput, disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                xs: 2,
                maxLength: '20',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
                borderBottom: '0'
            },
            {
                key: 'F785AltSystemReading1',
                value: isEnabledcondition(formData.F785AltSystemReading1, disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                xs: 2,
                type: 'number',
                maxLength: '10',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
                borderBottom: '0'
            },
            {
                key: 'F113AltHmireading2',
                value: isEnabledcondition(formData.F113AltHmireading2, disableAsLeftTestFields(formData)),
                isRequired: !(disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                xs: 2,
                type: 'number',
                maxLength: '10',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderBottom: '0',
                borderRight: '0',
            },
            {
                key: 'F79Deviation2Eu2',
                value: isEnabledcondition(AsLeftTableF79Deviation2Eu2Formula(formData), disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: true,
                xs: 2,
                textAlign: 'center',
                width: '100%',
                labelWidth: '0',
                height: '1.2rem',
                borderBottom: '0',
                borderRight: '0',
                inputMarginRight: '4px'
            }]
        },
        {
            key: 5,
            fields: [{
                key: 'F65Hmi2Inst3',
                value: isEnabledcondition(AsFoundTestTableF41HmiInst3Formula(formData), disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                xs: 2,
                width: '100%',
                labelWidth: '0',
                readOnly: true,
                height: '1.2rem',
                borderRight: '0',
                borderLeft: '0',
                marginLeft: '4px'
            },
            {
                key: 'F1062AltTestSpeed3',
                value: isEnabledcondition(formData.F1062AltTestSpeed3, disableAsLeftTestFields(formData)),
                isRequired: !(disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                maxLength: '10',
                xs: 2,
                type: 'number',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
            },
            {
                key: 'F1068AltSensorOutput',
                value: isEnabledcondition(formData.F1068AltSensorOutput, disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                xs: 2,
                maxLength: '20',
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
            },
            {
                key: 'AltSystemReading2',
                value: isEnabledcondition(formData.AltSystemReading2, disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                type: 'number',
                maxLength: '10',
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
            },
            {
                key: 'F114AltHmireading3',
                value: isEnabledcondition(formData.F114AltHmireading3, disableAsLeftTestFields(formData)),
                isRequired: !(disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: disableAsLeftTestFields(formData),
                type: 'number',
                maxLength: '10',
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.2rem',
                borderRight: '0',
            },
            {
                key: 'F80Deviation2Eu3',
                value: isEnabledcondition(AsLeftTableF80Deviation2Eu3Formula(formData), disableAsLeftTestFields(formData)),
                isDisabled: disableAsLeftTestFields(formData),
                readOnly: true,
                xs: 2,
                textAlign: 'center',
                width: '100%',
                labelWidth: '0',
                height: '1.2rem',
                borderRight: '0',
                inputMarginRight: '4px',
            }]
        },
        {
            key: 6,
            fields: [{
                key: 'NoData2',
                xs: 8,
                isLabel: true,
                padding: '5px 25px 18.5px 0'
            },
            {
                key: 'F103AltResultLabel',
                value: Result.AS_LEFT_RESULT_LABEL,
                readOnly: true,
                xs: 2,
                isLabelBold: true,
                textAlign: 'end',
                labelWidth: '0',
                width: '100%',
                height: '1.1rem',
                borderRight: '0',
                borderTop: '0',
                borderLeft: '0',
                borderBottom: '0',
            },
            {
                key: 'F103AltResult',
                value: AsLeftResultFormula(formData),
                readOnly: true,
                isCalculatedNew: true,
                xs: 2,
                labelWidth: '0',
                width: '100%',
                height: '1.1rem',
                isDisabled: disableAsLeftTestFields(formData),
                borderTop: disableAsLeftTestFields(formData) ? '' : '0',
                inputMarginRight: '4px',
                borderBottom: '0',
                marginBottom: '4px',
                textAlign: 'center',
                borderRight: '0',
            }]
        }]
});
